import { OutfitStyleOptionsType } from './types';

export const OUTFIT_STYLE_OPTIONS: OutfitStyleOptionsType = [
  { id: 'latex_seductress', title: 'Latex seductress' },
  { id: 'strict_teacher', title: 'Strict teacher' },
  { id: 'slutty_maid', title: 'Slutty maid' },
  { id: 'naughty_doctor', title: 'Naughty doctor' },
];
